<div class="row pt-0" *ngIf="connotes">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <a class="font-weight-bold" (click)="gotoConnotes()"><i class="fa fa-external-link fa-lg"></i> Switch to Old Connotes List</a>
        <div class="row pt-0 pb-3 mt-2">
            <div class="col-md-12">
                <button type="button" class="btn btn-secondary btn-sm dropdown-toggle mb-1 mr-1" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false" placement="bottom" ngbTooltip="Add" *ngIf="isEnabled('Create Booking')">
                    <span class="sr-only">Add</span>
                    <i class="fa fa-lg fa-plus"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Add</span>
                </button>
                <div class="dropdown-menu fs-12">
                    <a (click)="gotoAddBookingPage()" class="dropdown-item" href="javascript:void(0);">Add New
                        Booking</a>
                </div>

                <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="printer.printWithHeaderFooter('print-section', 'Connotes List')" placement="bottom"
                    [disabled]="count < 1" ngbTooltip="Print List">
                    <i class="fa fa-lg fa-print"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;
                        Print</span>
                </button>

                <div class="btn-group mr-1">
                    <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" [disabled]="count < 1" placement="bottom"
                        ngbTooltip="Export List">
                        <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;
                            Export</span>
                    </button>
                    <div class="dropdown-menu fs-12">
                        <a (click)="connote_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to
                            CSV</a>
                        <a (click)="connote_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to
                            Excel</a>
                        <a (click)="connote_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to
                            PDF</a>
                    </div>
                </div>

                <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1"
                    (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                    <i class="fa fa-lg fa-filter"></i>
                    <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
                </button>

                <div class="btn-group mr-1 ml-1">
                    <button type="button" class="btn btn-secondary btn-sm dropdown-toggle mb-1 mr-1"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" placement="bottom"
                        ngbTooltip="Show/Hide Columns">
                        <span class="sr-only">Toggle Dropdown</span>
                        <i class="fa fa-lg fa-check-square-o"></i><span
                            *ngIf="themeSettings.menu_type == 'default'">&nbsp;
                            Columns</span>
                    </button>
                    <div class="dropdown-menu fs-12" style="width: 150px;">
                        <div class="col-md-12 mb-3 fs-12">
                            <input type="checkbox" name="connote_week" [(ngModel)]="showConnoteWeek"> Connote Week #<br />
                            <input type="checkbox" name="start_date" [(ngModel)]="showStartDate"> Start Date<br />
                            <input type="checkbox" name="customer" [(ngModel)]="showCustomer"> Customer<br />
                            <input type="checkbox" name="reference" [(ngModel)]="showCustomerRef"> Reference #<br />
                            <input type="checkbox" name="control_no" [(ngModel)]="showControlNo"> Job Control #<br />
                            <input type="checkbox" name="type" [(ngModel)]="showType"> Type<br />
                            <input type="checkbox" name="charge_by" [(ngModel)]="showChargingMethod"> Charge by<br />
                            <input type="checkbox" name="price" [(ngModel)]="showPrice"> Price<br />
                            <input type="checkbox" name="service_fee" [(ngModel)]="showServiceFee"> Service Fee<br />
                            <input type="checkbox" name="fuel_levy" [(ngModel)]="showFuelLevy"> Fuel Levy<br />
                            <input type="checkbox" name="service_fee" [(ngModel)]="showServiceType"> Service Type<br />
                            <input type="checkbox" name="pickups" [(ngModel)]="showPickup"> Start/Pickup Location<br />
                            <input type="checkbox" name="deliveries" [(ngModel)]="showDelivery"> End/Delivery Location<br />
                            <input type="checkbox" name="pickup_datetime" [(ngModel)]="showPickupDatetime"> Start/Pickup Date<br />
                            <input type="checkbox" name="delivery_datetime" [(ngModel)]="showDeliveryDatetime"> End/Delivery Date<br />
                            <input type="checkbox" name="fleet" [(ngModel)]="showEquipments"> Fleet<br />
                            <input type="checkbox" name="drivers" [(ngModel)]="showDrivers"> Drivers<br />
                            
                        </div>
                    </div>
                </div>

                <button type="button" [ngClass]="(showAdvancedSearch)?'btn-success':'btn-secondary'"
                 class="btn btn-sm btn-secondary tt mb-1 mr-1" ngbTooltip="Advanced Search" placement="bottom"
                  (click)="showAdvancedSearch = showAdvancedSearch ? false : true; initAdvancedSearchForm()">
                    <i class="fa fa-lg fa-search"></i>
                </button>

                <span *ngIf="dateDropdown=='range'" class="pull-right ml-0 pl-0">&nbsp;
                    <input type="text" width="120" class="mb-1 ml-0" class="dateRangeInput" matInput
                        ngxDaterangepickerMd [locale]="locale" startKey="start" endKey="end" [showWeekNumbers]="true"
                        [showDropdowns]="true" [(ngModel)]="jobDateRange" (ngModelChange)="processDateRange()"
                        name="daterange" [autoApply]="true" opens="left" drops="down" [maxDate]="maxDate" />
                </span>

                <select [(ngModel)]="dateDropdown" (ngModelChange)="onChangeDateDropdown($event)"
                    class="input-sm dateFilter  btn btn-sm  btn-secondary mb-1 mr-1 pull-right">
                    <!-- <option value="all" [selected]="dateDropdown=='all'">All dates</option> -->
                    <option value="today" [selected]="dateDropdown=='today'">Today</option>
                    <option value="week" [selected]="dateDropdown=='week'">This Week</option>
                    <option value="month" [selected]="dateDropdown=='month'">This Month</option>
                    <option value="year" [selected]="dateDropdown=='year'">This Year</option>
                    <option value="7" [selected]="dateDropdown=='7'">Last 7 days</option>
                    <option value="14" [selected]="dateDropdown=='14'">Last 14 days</option>
                    <option value="30" [selected]="dateDropdown=='30'">Last 30 days</option>
                    <option value="60" [selected]="dateDropdown=='60'">Last 60 days</option>
                    <option value="90" [selected]="dateDropdown=='90'">Last 90 days</option>
                    <option value="range" [selected]="dateDropdown=='range'">Custom date range</option>
                </select>

                <select [(ngModel)]="statusDropdown" (ngModelChange)="onChangeStatusDropdown($event)"
                    class="dateFilter  btn btn-sm  btn-secondary mb-1 mr-1 pull-right">
                    <option value="current" [selected]="statusDropdown=='current'">Current Jobs</option>
                    <option value="completed" [selected]="statusDropdown=='completed'">Completed</option>
                    <option value="forinvoice" [selected]="statusDropdown=='forinvoice'">For Invoice</option>
                    <option value="archived" [selected]="statusDropdown=='archived'">Archived</option>
                    <option value="all" [selected]="statusDropdown=='all'">All Status</option>
                </select>

                <!-- <button class="btn btn-sm btn-outline-success mb-1 mr-1 pull-right" style="border-radius:6px;" (click)="loadedAllConnotes=false; getConnotes();">Apply</button>
                <button class="btn btn-sm btn-outline-danger mb-1 mr-1 pull-right" style="border-radius:6px;" (click)="resetFilters(); loadedAllConnotes=false; statusDropdown='current'; dateDropdown='14'; getConnotes();">Reset</button> -->
            </div>
        </div>

        <div class="row d-flex justify-content-center mx-3 mb-2" *ngIf="showAdvancedSearch">
            <div class="card border-0 box-shadow w-100">
                <div class="container p-3">
                    <div class="row">
                        <h5 class="ml-3">Advanced Search</h5>
                    </div>
                    <div class="row" [formGroup]="advancedSearchForm">
                        <div class="col">
                            Connote Week #: <input type="text" class="form-control" formControlName="connote_week">
                        </div>
                        <div class="col">
                            Reference Number: <input type="text" class="form-control" formControlName="ref_number">
                        </div>
                        <div class="col">
                            Control Number: <input type="text" class="form-control" formControlName="control_no">
                        </div>
                        <div class="col">
                            Driver: <input type="text" class="form-control" formControlName="driver">
                        </div>
                        <div class="col">
                            Customer: <input type="text" class="form-control" formControlName="customer">
                        </div>
                        <div class="col">
                            Fleet: <input type="text" class="form-control" formControlName="fleet">
                        </div>
                        <div class="col">
                            Date range: <input type="text" class="form-control" matInput
                                ngxDaterangepickerMd [locale]="advancedDateRangeLocale" startKey="start" endKey="end"
                                [showDropdowns]="true" formControlName="date_range"
                                [autoApply]="true" [closeOnAutoApply]="true" opens="left" drops="down"/>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-end mt-2">
                        <button class="btn btn-danger mr-3" (click)="resetAdvancedSearch()" *ngIf="!loadingAdvancedSearch">Reset</button>
                        <button class="btn btn-secondary mr-3" (click)="goAdvancedSearch(undefined)" *ngIf="!loadingAdvancedSearch">Go</button>
                        <button class="btn btn-secondary mr-3" *ngIf="loadingAdvancedSearch"><i class="fa fa-spinner fa-lg fa-spin"></i></button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-0 pb-0">
            <div class="col-md-12">

                Total Items: <span style="color: rgb(23, 98, 141);">{{ (totalItems !== null) ? (totalItems) :
                    "0"}}</span> | 

                Total Est. Price: $<span style="color: rgb(23, 98, 141);">
                    {{ ((totalPrice != null || totalPrice != 0) ? (totalPrice) : 0) | number:'1.2-2'}}</span>&nbsp;|&nbsp;

                <a *ngIf="filterType!='Local'" (click)="onClickJobType('Local');"><span [hidden]="filterJobType != 'Local'"><i
                            class="fa fa-check"></i>&nbsp;</span>Local:</a>
                <a *ngIf="filterType=='Local'" (click)="onClickJobType('Local');"><span [hidden]="filterJobType != 'Local'"><i
                                class="fa fa-check"></i>&nbsp;</span><strong>Local:</strong></a>
                <span style="color: rgb(23, 98, 141);"> {{ (totalLocal !== null) ? (totalLocal) : "0"}}</span> | 

                <a *ngIf="filterType!='Linehaul'" (click)="onClickJobType('Linehaul');"><span [hidden]="filterJobType != 'Line Haul'"><i
                            class="fa fa-check"></i>&nbsp;</span>Linehaul:</a>
                <a *ngIf="filterType=='Linehaul'" (click)="onClickJobType('Linehaul');"><span [hidden]="filterJobType != 'Line Haul'"><i
                            class="fa fa-check"></i>&nbsp;</span><strong>Linehaul:</strong></a>
                <span style="color: rgb(23, 98, 141);"> {{ (totalLinehaul !== null) ? (totalLinehaul) : "0"}}</span> |

                <a *ngIf="filterType!='Empty Run'" (click)="onClickJobType('Empty Run');"><span [hidden]="filterJobType != 'Empty Run'"><i
                            class="fa fa-check"></i>&nbsp;</span>Empty Run:</a>
                <a *ngIf="filterType=='Empty Run'" (click)="onClickJobType('Empty Run');"><span [hidden]="filterJobType != 'Empty Run'"><i
                                class="fa fa-check"></i>&nbsp;</span><strong>Empty Run:</strong></a>
                <span style="color: rgb(23, 98, 141);"> {{ (totalEmptyRun !== null) ? (totalEmptyRun) : "0"}}</span>&nbsp;|&nbsp;
                
                <a *ngIf="filterType!='Tow Haul'" (click)="onClickJobType('Tow Haul');"><span [hidden]="filterJobType != 'Tow Haul'"><i
                        class="fa fa-check"></i>&nbsp;</span>Tow Haul:</a>
                <a *ngIf="filterType=='Tow Haul'" (click)="onClickJobType('Tow Haul');"><span [hidden]="filterJobType != 'Tow Haul'"><i
                    class="fa fa-check"></i>&nbsp;</span><strong>Tow Haul:</strong></a>
                <span style="color: rgb(23, 98, 141);"> {{ (totalTowhaul !== null) ? (totalTowhaul) : "0"}}</span>&nbsp;|&nbsp;
                
                <a *ngIf="filterType!='Trailer Hire'" (click)="onClickJobType('Trailer Hire');"><span [hidden]="filterJobType != 'Trailer Hire'"><i
                    class="fa fa-check"></i>&nbsp;</span>Trailer Hire:</a>
                <a *ngIf="filterType=='Trailer Hire'" (click)="onClickJobType('Trailer Hire');"><span [hidden]="filterJobType != 'Trailer Hire'"><i
                    class="fa fa-check"></i>&nbsp;</span><strong>Trailer Hire:</strong></a>
                <span style="color: rgb(23, 98, 141);"> {{ (totalTrailerHire !== null) ? (totalTrailerHire) : "0"}}</span>&nbsp;|&nbsp;
                    
                <a *ngIf="filterType!='Changeover'" (click)="onClickJobType('Changeover');"><span [hidden]="filterJobType != 'Changeover'"><i
                            class="fa fa-check"></i>&nbsp;</span>Changeover:</a> 
                <a *ngIf="filterType=='Changeover'" (click)="onClickJobType('Changeover');"><span [hidden]="filterJobType != 'Changeover'"><i
                    class="fa fa-check"></i>&nbsp;</span><strong>Changeover:</strong></a> 
                <span style="color: rgb(23, 98, 141);"> {{ (totalChangeover !== null) ? (totalChangeover) : "0"}}</span>&nbsp;&nbsp;

                <a (click)="onClickStatus(''); onClickJobType(''); forceReset=true; resetFilters();" container="body" placement="top" ngbTooltip="Reset Filter"><i
                        class="fa fa-rotate-left"></i></a>

                <a [hidden]="statusDropdown != 'archived' && statusDropdown != 'all'"
                    (click)="onClickStatus('Cancelled');"><span
                        class="badge badge-pill badge-cancelled pull-right"><span
                            [hidden]="filterStatus != 'Cancelled'"><i
                                class="fa fa-check"></i>&nbsp;</span>Cancelled</span></a>
                <a [hidden]="statusDropdown != 'completed' && statusDropdown != 'forinvoice' && statusDropdown != 'archived' && statusDropdown != 'all'"
                    (click)="onClickStatus('Completed');"><span class="badge badge-pill is-connote-completed pull-right"><span
                            [hidden]="filterStatus != 'Completed'"><i
                                class="fa fa-check"></i>&nbsp;</span>Completed</span></a>
                <a [hidden]="statusDropdown != 'current' && statusDropdown != 'all'"
                    (click)="onClickStatus('Processing');"><span
                        class="badge badge-pill badge-processing pull-right"><span
                            [hidden]="filterStatus != 'Processing'"><i
                                class="fa fa-check"></i>&nbsp;</span>Processing</span></a>
                <a [hidden]="statusDropdown != 'current' && statusDropdown != 'all'"
                    (click)="onClickStatus('Dispatched');"><span
                        class="badge badge-pill badge-dispatched pull-right"><span
                            [hidden]="filterStatus != 'Dispatched'"><i
                                class="fa fa-check"></i>&nbsp;</span>Dispatched</span></a>
                <a [hidden]="statusDropdown != 'current' && statusDropdown != 'all'"
                    (click)="onClickStatus('Pending');"><span class="badge badge-pill badge-pending pull-right"><span
                            [hidden]="filterStatus != 'Pending'"><i
                                class="fa fa-check"></i>&nbsp;</span>Pending</span></a>
                <a [hidden]="statusDropdown != 'current' && statusDropdown != 'all'"
                    (click)="onClickStatus('Late');"><span class="badge badge-pill badge-danger pull-right"><span
                            [hidden]="filterStatus != 'Late'"><i
                                class="fa fa-check"></i>&nbsp;</span>Late</span></a>
            </div>
        </div>
        <ngx-loading [show]="loadingIndicator"></ngx-loading>
        <ngx-datatable #connotesTable [loadingIndicator]="loadingIndicator" class="material" 
            [rows]="connotes" 
            [columnMode]="'force'"
            [footerHeight]="30" 
            [rowHeight]="'auto'" 
            [limit]="30" 
            [selected]="selected"
            [selectionType]="sType" 
            [scrollbarH]="true" 
            (select)="onSelect($event)"
            [headerHeight]="showFilters?50:30"
            [count]="isServerPagination && isFilterEmpty && filterType == '' && filterStatus == '' ? countServerPagination : count"
            [externalPaging]="isServerPagination"
            (page)="isServerPagination ? goAdvancedSearch($event) : null">
           

            <!-- Row Detail Template -->
            <ngx-datatable-row-detail [rowHeight]="'auto'" #myDetailRow (toggle)="onDetailToggle($event)">
                <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
                    <div style="padding-left:45px;">
                        <div class="row">
                            <span style="width: 15%;">
                                <div><strong>{{ row.control_no }}</strong></div>
                                <div>{{ row.service_type }}</div>
                                <div>Charged <span [hidden]="row.charging_method == 'Hourly'">by</span>&nbsp;
                                    <span *ngIf="row.charging_method != 'Pallets'">{{row.charging_method}}</span><span *ngIf="row.charging_method == 'Pallets'">Freight Packaging</span></div>
                                <!-- <div *ngIf="row.is_invoiced == '1' && row.is_empty_run == '0'">Job is already
                                    invoiced</div>
                                <div *ngIf="row.is_invoiced == '0' && row.is_empty_run == '0'">Job is already
                                    invoiced</div> -->

                                <div *ngIf="row.run_type_id == '1'">Local </div>
                                <div *ngIf="row.run_type_id == '2'">Linehaul</div>
                                <div *ngIf="row.run_type_id == '3'">Empty Run </div>
                                <div *ngIf="row.run_type_id == '4'">Tow Haul </div>
                                <div *ngIf="row.run_type_id == '5'">Trailer Hire </div>
                                </span>
                            <span style="width: 15%;">
                                <div *ngFor="let f of row.files">
                                    <div *ngIf="f.label =='Connote File' || f.label =='PPD' || f.label =='POD' || f.label =='CSDP'" >
                                        <strong>{{f.label}}: </strong><a href="{{url.cloudStorage}}/{{f.folder}}/{{f.file}}" target="_new">{{f.file}}</a>
                                    </div>
                                </div>
                                <div *ngIf="row.sdp_file !==null">
                                    <strong>SDP: </strong><a href="{{url.cloudStorage}}/sdp/{{row.sdp_file}}" target="_new">{{row.sdp_file}}</a>
                                </div>

                            </span>
                            <span style="width: 20%;" *ngIf="row.packagings?.length > 0">
                                <strong>Packagings:</strong><br/>
                                <i *ngFor="let package of row.packagings">{{package.quantity}}x  [<b class="text-primary">{{package.type}}</b>] L{{package.length}} x W{{package.width}} x H{{package.height}} - {{package.weight}}kg <br/></i>
                            </span>
                            <span style="width: 20%;">
                                <div><strong>Estimated Total Cost: </strong>
                                    <!-- <span *ngIf="row.total_cost > 0">$ {{ row.total_cost | number:'1.2-2'}}</span>
                                    <span *ngIf="(getPrice(row)!='UNKNOWN PRICE') && (row.total_cost ==0.00 || row.total_cost ==0 || row.total_cost =='' || row.total_cost ==null)">$ {{ getPrice(row) | number:'1.2-2'}}</span> -->
                                    <span *ngIf="getAmount(row) > 0">$ {{ getAmount(row)| number:'1.2-2'}}</span>
                                    <span *ngIf="getAmount(row) == 0"><i>UNKNOWN PRICE</i> </span>
                                </div>
                                <div *ngIf="row.special_instructions!='' && row.special_instructions!=null"><strong>SPECIAL INSTRUCTIONS: <i class="text-danger">{{ row.special_instructions }}</i></strong></div>
                            </span>
                            <span style="width: 20%;" *ngIf="row.notes?.length > 0">
                                <div *ngIf="row.notes?.length > 0"><strong>Notes:</strong><br/> 
                                    <i *ngFor="let note of row.notes"><b>{{note.action}}</b> <b class="text-success">{{note.location}}</b> <span class="text-primary">{{note.notes}}</span><br/></i>
                                </div>
                            </span>
                        </div>


                    </div>
                </ng-template>
            </ngx-datatable-row-detail>

            <ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false"
            [canAutoResize]="false">
                <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
                    <a href="javascript:void(0)" [class.datatable-icon-right]="!expanded"
                        [class.datatable-icon-down]="expanded" title="Expand/Collapse Row"
                        (click)="toggleExpandRow(row)">
                    </a>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column [width]="30" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false" 
                [headerCheckboxable]="true" [checkboxable]="getCheckboxStatus" [cellClass]="getCellClass" 
                *ngIf="statusDropdown=='completed' || filterStatus == 'Completed'">
            </ngx-datatable-column>
            
            <ngx-datatable-column [width]="120" prop="id" name="Operations" headerClass="header"
                [cellClass]="getCellClass" [sortable]="false">

                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div class="text-left" style="display:inline;padding:0px">
                        <a container="body" placement="top" ngbTooltip="Details" [routerLink]="['details', value]"><i
                                class="fa fa-lg fa-book"></i>&nbsp;</a>
                        <a container="body" placement="top" ngbTooltip="Edit" *ngIf="row.run_status_id == 1" [routerLink]="['/bookings/edit', value]"><i class="fa fa-lg fa-pencil"></i>&nbsp;</a>
                        <a [routerLink]="['/bookings/rebook', value]" placement="right"
                        ngbTooltip="Rebook this entry"><i class="fa fa-lg fa-recycle"></i>&nbsp;</a>
                        <a container="body" placement="top" ngbTooltip="Compose Invoice" (click)="composeInvoice(value)" 
                        placement="right" *ngIf="(row.is_invoice_ready == 1 &&  row.is_invoiced == 0) && isEnabled('Select')"><i class="fa fa-usd" aria-hidden="true"></i>&nbsp;</a>
                        <a container="body" placement="top" ngbTooltip="Invoice Details" [routerLink]="['/invoices/details/', row.invoice_id]" 
                         placement="right" *ngIf="(row.is_invoiced == 1) && isEnabled('Invoices')"><i class="fa fa-money" aria-hidden="true"></i>&nbsp;</a>
                        <a *ngIf="row.run_status_id == '1'" (click)="openModalCancelJob(row)" placement="right" ngbTooltip="Cancel Job">
                        <i class="fa fa-lg fa-calendar-times-o" [hidden]="spinner == true"></i>&nbsp;</a>
                        <div ngbDropdown container="body" style="position:static;display:inline;padding:0px;">
                            <a class="btn btn-sm" *ngIf="row.is_invoiced==0 && row.run_status_id==4 && row.is_invoice_ready == 0 && row.run_type_id!=3"
                            ngbDropdownToggle><i class="fa fa-lg fa-check-square-o text-danger"></i></a>
                            <div ngbDropdownMenu style="padding:0px;">
                              <button (click)="openModalMarkForInvoice(row)" class="dropdown-item">Accept</button>
                              <button (click)="markCreateInvoice(row.id, value)" class="dropdown-item" *ngIf="isEnabled('Select')">Accept & Create</button>
                              <button [disabled]="generateButton(row)" class="dropdown-item" (click)="acceptAndSend(row)" *ngIf="isEnabled('Select')">Accept & Send</button>
                            </div>&nbsp;
                        </div>

                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="connote_week" name="Connote Week #" headerClass="header" [cellClass]="getCellClass" *ngIf="showConnoteWeek"
                [sortable]="true">
                <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters">
                        <input type="text" [(ngModel)]="filterConnoteWeek" style="height:17px" 
                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                            (keyup)="updateFilter()" />
                    </span>
                </ng-template>
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div title="{{value}}"
                        style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; ">
                        {{value}}
                    </div>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="start_datetime" name="Start Date" headerClass="header"
                [cellClass]="getCellClass" *ngIf="showStartDate" [sortable]="true">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%;"
                        class="text-left">
                        <span title="{{row.start_datetime}}">{{ (row.start_datetime == null || row.start_datetime == '0000-00-00 00:00:00') ? "No Date" : (row.start_datetime |
                            date: 'dd MMM yyyy') }}</span>
                    </div>
                </ng-template>

            </ngx-datatable-column>
            <ngx-datatable-column prop="customer_reference_no" name="Reference #" headerClass="header" [cellClass]="getCellClass" *ngIf="showCustomerRef"
                [sortable]="true">
                <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                     <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters">
                        <input type="text" [(ngModel)]="filterCustomerRef" style="height:17px" 
                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                            (keyup)="updateFilter()" />
                    </span>
                </ng-template>
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div title="{{value}}"
                        style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; ">
                        {{value}}
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="customer" headerClass="header" [cellClass]="getCellClass" *ngIf="showCustomer"
                [sortable]="true">
                <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters">
                        <input type="text" [(ngModel)]="filterCustomer" style="height:17px"
                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                            (keyup)="updateFilter()" />
                    </span>
                </ng-template>
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div title="{{value}}"
                        style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; ">
                        {{value}}
                        <!--                     <span *ngIf="row.run_type_id == '3'"><i>Empty Run</i></span>
 -->
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="control_no" name="Control No." headerClass="header" [cellClass]="getCellClass"
                class="text-left" *ngIf="showControlNo">

                <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters">
                        <input type="text" [(ngModel)]="filterControlNo" style="height:17px"
                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                            (keyup)="updateFilter()" />
                    </span>
                </ng-template>
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <span class="badge badge-pill badge-warning" *ngIf="row.changeover_flag == 1" placement="bottom" ngbTooltip="Changeover">C</span>
                    <span class="badge badge-pill badge-warning" *ngIf="row.changeover_partial_flag == 1" style="background: linear-gradient(to left, white 50%, #FE9700 50%);">C</span>
                    {{value}}
                </ng-template>
                <!-- <span *ngIf="hasPointDone(row.pickups_full)" class="badge badge-pill badge-success"
                placement="bottom" ngbTooltip="Pickup done"> -->
            </ngx-datatable-column>

            <ngx-datatable-column prop="job_type" name="Type" headerClass="header" [cellClass]="getCellClass"
                class="text-left" *ngIf="showType">

                <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters">
                        <input type="text" [(ngModel)]="filterType" style="height:17px"
                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                            (keyup)="updateFilter()" />
                    </span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="charging_method" name="Charge by" headerClass="header" [cellClass]="getCellClass"
                class="text-left" *ngIf="showChargingMethod">

                <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters">
                        <input type="text" [(ngModel)]="filterChargingMethod" style="height:17px"
                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                            (keyup)="updateFilter()" />
                    </span>
                </ng-template>
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <span *ngIf="row.charging_method != 'Pallets'"> {{row.charging_method}}</span><span *ngIf="row.charging_method == 'Pallets'"> Freight Packaging</span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="price" name="Price" headerClass="header" [cellClass]="getCellClass"
                class="text-left" *ngIf="showPrice">

                <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters">
                        <input type="text" [(ngModel)]="filterPrice" style="height:17px"
                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                            (keyup)="updateFilter()" />
                    </span>
                </ng-template>
                <ng-template let-value="value" ngx-datatable-cell-template>
                    <span *ngIf="value">$&nbsp;{{value}}</span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="service_fee" name="Service Fee" headerClass="header" [cellClass]="getCellClass"
            class="text-left" *ngIf="showServiceFee">

            <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                <span (click)="sort()">{{column.name}}</span>
                <span *ngIf="showFilters">
                    <input type="text" [(ngModel)]="filterServiceFee" style="height:17px"
                        class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                        (keyup)="updateFilter()" />
                </span>
            </ng-template>
            <ng-template let-value="value" ngx-datatable-cell-template>
                <span *ngIf="value > 0">{{value}}&nbsp;%</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="fuel_levy" name="Fuel Levy" headerClass="header" [cellClass]="getCellClass"
            class="text-left" *ngIf="showFuelLevy">

            <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                <span (click)="sort()">{{column.name}}</span>
                <span *ngIf="showFilters">
                    <input type="text" [(ngModel)]="filterFuelLevy" style="height:17px"
                        class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                        (keyup)="updateFilter()" />
                </span>
            </ng-template>
            <ng-template let-value="value" ngx-datatable-cell-template>
                <span *ngIf="value > 0">{{value}}&nbsp;%</span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column prop="service_type" name="Service Type" headerClass="header" [cellClass]="getCellClass"
            class="text-left" *ngIf="showServiceType">

            <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                <span (click)="sort()">{{column.name}}</span>
                <span *ngIf="showFilters">
                    <input type="text" [(ngModel)]="filterServiceType" style="height:17px"
                        class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                        (keyup)="updateFilter()" />
                </span>
            </ng-template>
        </ngx-datatable-column>

            <ngx-datatable-column prop="pickups" name="Start/Pickup Location" headerClass="header" [cellClass]="getCellClass"
                *ngIf="showPickup" [width]="180">
                <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters">
                        <input type="text" [(ngModel)]="filterPickups" style="height:17px"
                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                            (keyup)="updateFilter()" />
                    </span>
                </ng-template>

                
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <ng-template #valueToolTip>

                        <div class="text-left">
                            <div [innerHTML]="row.pickups_full"></div>
                            <a ngxClipboard [cbContent]="getCopy(row.pickups_full)"><i
                                    class="fa fa-copy"></i></a>
                        </div>
                    </ng-template>
                    <a [ngbTooltip]="valueToolTip" triggers="click" placement="top" *ngIf="row.pickups && row.pickups != ''"
                                container="body">
                                <div style="padding-right:20px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; ">
                                    <span *ngIf="hasPointDone(row.pickups_full)" class="badge badge-pill badge-success"
                                        placement="bottom" ngbTooltip="Pickup done" container="body">
                                        <i class="fa fa-check"></i>&nbsp;
                                    </span>
                                    <span *ngIf="hasPointDone(row.pickups_full)">&nbsp;</span>
                                    <span *ngIf="row?.late_pickup == true && hasPointDone(row.pickups_full) == false" class="badge badge-pill badge-danger" [ngbTooltip]="late_pickup_sites" container="body" placement="bottom">
                                        <i class="fa fa-exclamation fa-lg"></i>&nbsp;
                                    </span>
                                    <span *ngIf="row.pickups != '' && row.pickups && row.pickups != null">{{row.pickups}}</span>
                                    
                                </div>
                                
                    </a>

                    <ng-template #late_pickup_sites>
                        <span>Late Pickup</span><br>
                        <div *ngFor="let pickup of row?.plan_pickups" class="text-left">
                            <span *ngIf="pickup.late == true" class="text-left">{{pickup.street_no}} {{pickup.street}} {{pickup.short_text}}</span><br>
                        </div>
                    </ng-template>

                    <div *ngIf="(!row.pickups || row.pickups == '') && row.run_type_id != 3">TBA</div>
                    <!-- <div *ngIf="!row.pickups || row.pickups == ''">-</div> -->
                </ng-template>





                <!-- <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div placement="right" ngbTooltip="{{value}}"
                        style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%;">
                        <span *ngIf="row.pickups">{{row.pickups}}</span>
                        <span *ngIf="!row.pickups">TBA</span>
                    </div>
                </ng-template> -->
            </ngx-datatable-column>

            <ngx-datatable-column prop="deliveries" name="End/Delivery Location" headerClass="header" [cellClass]="getCellClass"
                *ngIf="showDelivery" [width]="180">
                <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters">
                        <input type="text" [(ngModel)]="filterDeliveries" style="height:17px"
                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                            (keyup)="updateFilter()" />
                    </span>
                </ng-template>


                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <ng-template #valueToolTip>

                        <div class="text-left">
                            <div [innerHTML]="row.deliveries_full"></div>
                            <a ngxClipboard [cbContent]="getCopy(row.deliveries_full)"><i
                                    class="fa fa-copy"></i></a>
                        </div>
                    </ng-template>
                    <a [ngbTooltip]="valueToolTip" triggers="click" placement="top" *ngIf="row.deliveries && row.deliveries != ''"
                                container="body">
                                <div style="padding-right:20px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; ">
                                    <span *ngIf="hasPointDone(row.deliveries_full)" class="badge badge-pill badge-success"
                                        placement="bottom" ngbTooltip="Delivery done" container="body">
                                        <i class="fa fa-check"></i>
                                    </span>
                                    <span *ngIf="hasPointDone(row.deliveries_full)">&nbsp;</span>
                                    <span *ngIf="row?.late_deliver == true && hasPointDone(row.deliveries_full) == false" class="badge badge-pill badge-danger" [ngbTooltip]="late_delivery_sites" container="body" placement="bottom">
                                        <i class="fa fa-exclamation fa-lg"></i>&nbsp;
                                    </span>
                                    <span *ngIf="row.deliveries != '' && row.deliveries && row.deliveries != null">{{row.deliveries}}</span>
                                    
                                </div>
                                
                    </a>

                    <ng-template #late_delivery_sites>
                        <span>Late Delivery</span><br>
                        <div *ngFor="let delivery of row?.plan_deliveries" class="text-left">
                            <span *ngIf="delivery.late == true" class="text-left">{{delivery.street_no}} {{delivery.street}} {{delivery.short_text}}</span><br>
                        </div>
                    </ng-template>

                    <div *ngIf="(!row.deliveries || row.deliveries == '') && row.run_type_id != 3">TBA</div>
                </ng-template>


<!--                 <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div placement="right" ngbTooltip="{{value}}"
                        style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%;">
                        <span *ngIf="row.deliveries">{{row.deliveries}}</span>
                        <span *ngIf="!row.deliveries">TBA</span>

                    </div>
                </ng-template>
 -->            </ngx-datatable-column>

            <ngx-datatable-column prop="pickup_datetime" name="Start/Pickup Date" headerClass="header"
                [cellClass]="getCellClass" *ngIf="showPickupDatetime" [sortable]="true">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%;"
                        class="text-left">
                        <ng-container *ngIf="row.trailer_hire_start == null; else trailerHireStartRunType">
                            <span title="{{ row.pickup_datetime != '0000-00-00 00:00:00' ? (row.pickup_datetime | date: 'dd MMM yyyy h:mm a') : 'No Date' }}">
                                {{ (row.pickup_datetime !='0000-00-00 00:00:00') ? (row.pickup_datetime | date: 'dd MMM yyyy h:mm a') : "No Date" }}
                            </span>
                        </ng-container>
                        <ng-template #trailerHireStartRunType>
                            <span title="{{ row.trailer_hire_start != null ? (row.trailer_hire_start | date: 'dd MMM yyyy') : 'No Date' }}">
                                {{ (row.trailer_hire_start != null) ? (row.trailer_hire_start | date: 'dd MMM yyyy') : "No Date" }}
                            </span>
                        </ng-template>
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="delivery_datetime" name="End/Delivery Date" headerClass="header"
                [cellClass]="getCellClass" *ngIf="showDeliveryDatetime" [sortable]="true">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%;"
                        class="text-left">
                        <ng-container *ngIf="row.trailer_hire_end == null; else trailerHireEndRunType">
                            <span title="{{ row.pickup_datetime != '0000-00-00 00:00:00' ? (row.delivery_datetime | date: 'dd MMM yyyy h:mm a') : 'No Date'}}">
                                {{ (row.delivery_datetime !='0000-00-00 00:00:00') ? (row.delivery_datetime | date: 'dd MMM yyyy h:mm a') : "No Date" }}
                            </span>
                        </ng-container>
                        <ng-template #trailerHireEndRunType>
                            <span title="{{ row.trailer_hire_end != null ? (row.trailer_hire_end | date: 'dd MMM yyyy') : 'No Date'}}">
                                {{ (row.trailer_hire_end != null) ? (row.trailer_hire_end | date: 'dd MMM yyyy') : "No Date" }}
                            </span>
                        </ng-template>
                    </div>
                </ng-template>
            </ngx-datatable-column>


            <ngx-datatable-column prop="booking_fleet" name="Fleet" headerClass="header" [cellClass]="getCellClass"
                class="text-left" *ngIf="showEquipments">

                <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters">
                        <input type="text" [(ngModel)]="filterEquipments" style="height:17px"
                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                            (keyup)="updateFilter()" />
                    </span>
                </ng-template>

                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div placement="bottom" ngbTooltip="{{row.run_status_id == 1 ? row.booking_fleet : row.dispatch_equipments}}"
                        style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%;">
                        <span *ngIf="row.run_status_id == 1">{{row.booking_fleet}}</span>
                        <span *ngIf="row.run_status_id>1">{{row.dispatch_equipments}}</span>

                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="booking_drivers" name="Drivers" headerClass="header" [cellClass]="getCellClass"
            class="text-left" *ngIf="showDrivers">

            <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                <span (click)="sort()">{{column.name}}</span>
                <span *ngIf="showFilters">
                    <input type="text" [(ngModel)]="filterDrivers" style="height:17px"
                        class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                        (keyup)="updateFilter()" />
                </span>
            </ng-template>

            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div placement="bottom" ngbTooltip="{{row.run_status_id == 1 ? row.booking_drivers : row.dispatch_drivers}}"
                    style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%;">
                    <span *ngIf="row.run_changeover!= null" class="badge badge-pill badge-warning">C</span>&nbsp;
                    <span *ngIf="row.run_status_id == 1">{{row.booking_drivers}}</span>
                    <span *ngIf="row.run_status_id>1">{{row.dispatch_drivers}}</span>

                </div>
            </ng-template>
        </ngx-datatable-column>

        </ngx-datatable> <!-- END OF BOOKINGS LIST TABLE -->
        <div *ngIf="statusDropdown=='completed' || filterStatus == 'Completed'">
            <br/>
            <div class="col-md-12">
                <button type="submit" class="btn btn-sm btn-success mb-1 mr-1"
                    [disabled]="!selected.length" (click)="openAccept()" title="Mark selected job/s for invoicing">
                    <span>Accept</span>
                </button>&nbsp;

                <!-- <button type="submit" class="btn btn-sm btn-success mb-1 mr-1"
                    [disabled]="!selected.length" (click)="openAcceptCreate()" title="Mark and create selected job/s for invoicing">
                    <span>Accept & Create</span>
                </button> -->
            </div>
        </div>

        <!-- START PRINT-->
        <div id="print-section" style="display:none">
            
            <table style="width:100%" class="table table-striped">
                <thead>
                    <tr><th><div class="header-space">&nbsp;</div></th></tr>
                    <tr class="thead2">
                        <th *ngIf="showConnoteWeek">CONNOTE WEEK #</th>
                        <th *ngIf="showStartDate">START DATE</th>
                        <th *ngIf="showCustomer">CUSTOMER</th>
                        <th *ngIf="showControlNo">JOB CONTROL #</th>
                        <th *ngIf="showPickup">PICKUP</th>
                        <th *ngIf="showDelivery">DELIVERY</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of connotes" nobr="true">
                        <td *ngIf="showConnoteWeek">{{row.connote_week}}</td>
                        <td *ngIf="showStartDate">{{ (row.start_datetime == null || row.start_datetime == '0000-00-00 00:00:00') ? "No Date" : (row.start_datetime | date: 'dd MMM yyyy')
                            }}
                        </td>
                        <td *ngIf="showCustomer">{{row.customer}}</td>
                        <td *ngIf="showControlNo">{{row.control_no}}</td>
                        <td *ngIf="showPickup">{{row.pickups}}</td>
                        <td *ngIf="showDelivery">{{row.deliveries}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td>
                            <div class="footer-space">&nbsp;</div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div><!-- END PRINT -->

    </div>
</div>

<!-- START OF ACCEPT FOR INVOICE MODAL  -->
<ng-template #modalAccept let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Mark All for Invoicing</h5>
        <button type="button" class="close" (click)="resetBulkAcceptVariables();close();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12" *ngIf="this.bulk_count > 0">
                <span> There are total of <strong style="color:red">{{bulk_count}}</strong> candidate for invoice.</span><br/>
                <div  *ngFor="let j of selected_bulk_accept" style="display:inline-block">
                    <span style="color:blue">&#8226;</span>&nbsp; <small><strong>{{j.control_no}}</strong>({{j.customer}})</small> &nbsp;
                </div><br/>
            </div>
            <div class="col-md-12" *ngIf="bulk_count == 0">Connote/s selected are not candidate/s for invoice.</div>
        </div>
    </div>
    <div class="modal-footer">
        <button *ngIf="bulk_count > 0" type="button" class="btn btn-sm btn-danger" (click)="bulkAccept()">Confirm</button>&nbsp;
        <button type="button" class="btn btn-sm btn-secondary" (click)="resetBulkAcceptVariables();close();">Cancel</button>
    </div>
</ng-template>
<!-- END OF ACCEPT FOR INVOICE MODAL  -->

<!-- START OF ACCEPT AND CREATE FOR INVOICE MODAL  -->
<!-- <ng-template #modalAcceptCreate let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Mark & Create All for Invoice</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
                <div *ngFor="let j of selected" style="display:inline-block">
                    <span style="color:blue">&#8226;</span>&nbsp; <small><strong>{{j.control_no}}</strong>({{j.customer}})</small> &nbsp;
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger" (click)="bulkAcceptCreate()">Confirm</button> &nbsp;
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template> -->
<!-- END OF ACCEPT AND CREATE FOR INVOICE MODAL  -->

<!-- START OF CANCEL JOB MODAL  -->
<ng-template #modalCancelJob let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Cancelling Job</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <strong>Are you sure you want to cancel Job Control No.&nbsp;<span style="color:red;">{{control_no}}</span>?</strong>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger" (click)="cancelJob(job_to_cancel)">Yes</button> &nbsp;
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">No</button>
    </div>
</ng-template>
<!-- END OF CANCEL JOB MODAL  -->

<!-- START OF MARK JOB FOR INVOICING  -->
<ng-template #modalMarkJobForInvoicing let-close="close">
    <div class="modal-header">
        <div class="col px-0">
            <div class="row no-gutters pt-0">
                <span class="col-1"><i class="fa fa-2x fa-calendar-check-o" style="color:green"></i></span>
                <div class="col">
                    <h5 class="modal-title">Mark Job for Invoicing</h5>
                </div>
            </div>
        </div>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
                <b>Do you really want to mark this job for invoicing?</b> <br />
                Customer: {{selected[0].customer}} <br />
                Job Control No.: {{selected[0].control_no}} <br />
                Date Done:
                {{ (selected[0].arrival_date !== null) ? (selected[0].arrival_date | date: 'dd MMM yyyy') : "No Date"  }}
                <br />
            </div>
        </div>

    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-success" (click)="onMarkJobForInvoicing(currentId)">
            Accept</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()" ngbAutofocus>
            Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL MARK JOB FOR INVOICING  -->